import React, { useState, useEffect } from 'react'
import algoliasearch from 'algoliasearch/lite'
import { useRouter } from 'next/router'
import { InstantSearch } from 'react-instantsearch-dom'
import qs from 'qs'

import {
  createURL,
  searchStateToUrl,
  urlToSearchState,
} from '@mindfulchefuk/helpers/js/algolia'

import useScrollToTop from '@mindfulchefuk/hooks/useScrollToTop'
import { RecipeResults } from '@mindfulchefuk/components/Recipes/RecipeResults'
import { SearchBox } from './SearchBox/SearchBox'
import { DesktopFilters } from './Filters/DesktopFilters'
import { MobileFilters } from './Filters/MobileFilters'

const searchClient = algoliasearch(
  process.env.NEXT_PUBLIC_ALGOLIA_APP_ID,
  process.env.NEXT_PUBLIC_ALGOLIA_API_KEY
)

const DEBOUNCE_TIME = 400

const Search = ({ filterDefaults }) => {
  const router = useRouter()

  const [searchState, setSearchState] = useState(
    urlToSearchState(createURL(router.query))
  )
  const [debouncedSetState, setDebouncedSetState] = useState(null)

  useEffect(() => {
    setSearchState(urlToSearchState(`?${qs.stringify(router.query)}`))
    // FIX - eslint react-hooks
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchStateToUrl(router.pathname, router.query)])

  const onSearchStateChange = (updatedSearchState) => {
    clearTimeout(debouncedSetState)

    setDebouncedSetState(
      setTimeout(() => {
        router.replace(
          searchStateToUrl(router.pathname, updatedSearchState),
          undefined,
          { scroll: false }
        )
      }, DEBOUNCE_TIME)
    )

    setSearchState(updatedSearchState)
  }

  useScrollToTop([router.query], 'smooth')

  return (
    <InstantSearch
      searchClient={searchClient}
      indexName={process.env.NEXT_PUBLIC_ALGOLIA_INDEX_NAME}
      searchState={searchState}
      onSearchStateChange={onSearchStateChange}
      createURL={createURL}
    >
      <SearchBox
        placeholder="Search for a recipe or ingredient"
        defaultRefinement={searchState.query}
      />
      <DesktopFilters filterDefaults={filterDefaults} />
      <MobileFilters filterDefaults={filterDefaults} />
      <RecipeResults defaultRefinement={1} />
    </InstantSearch>
  )
}

export default Search
